import React, { useEffect, useState } from "react";
import { MdArrowDropDown } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { IoEye } from "react-icons/io5";

import axios from "axios";

import { toast } from "react-toastify";
import Constant from "../Components/Utils/Constant";


const AffiliateUserEditform = ({ subscriptionRes, cuponRes, editPopup, setEditPopup }) => {
  console.log("meeowow", editPopup)
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [newPassword, setPassword] = useState("");
  const [device, setDevice] = useState("");
  const [subscription, setSubscription] = useState("");
  const [date, setDate] = useState({
    day: "",
    month: "",
    year: "",
  });
  const [address, setAddress] = useState("");
  const [proffesion, setProffesion] = useState("");
  const [gst, setGst] = useState("");
  const [companyname, setCompanyname] = useState("");
  const [createdby, setCreatedby] = useState("");
  const [devicesID, setDevicesID] = useState("");

  const [userName, setUserName] = useState("");

  const [SelectedUser, setSelectedUser] = useState(editPopup);
  const [togglePassword, setTogglePassword] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isPhoneValid, setIsPhoneValid] = useState(true);
  const [cuponapplied, setCuponapplied] = useState("");
  const [collectedamount, setCollectedamount] = useState("");
  // const [isGstValid, setIsGstValid] = useState(true);

  const handleClose = () => {
    setEditPopup(false);
  };

  useEffect(() => {
    const storedName = localStorage.getItem("name");

    if (storedName) {
      setUserName(storedName);
      setCreatedby(storedName);
    } else {
      setUserName("Unauthorized");
      setCreatedby("Unauthorized");
    }
  }, []);

  useEffect(() => {
    setValue();
  }, [SelectedUser]);

  const setValue = () => {
    setName(SelectedUser.name);
    setEmail(SelectedUser.email);
    setPhone(SelectedUser.phone);
    setAddress(SelectedUser.address);
    setDevice(SelectedUser.device);
    setSubscription(SelectedUser.subscription);
    setCompanyname(SelectedUser.companyname);
    setPassword(SelectedUser.newPassword);
    setGst(SelectedUser.gst);
    setProffesion(SelectedUser.proffesion);
    setDate(SelectedUser.date);
    setCollectedamount(SelectedUser.collectedamount)
    setCuponapplied(SelectedUser.cuponapplied)
  };
  // valiadations
  console.log(SelectedUser.name)

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const validatePhone = (phone) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phone);
  };
  // const validateGst = (gst) => {
  //   // GST number regex (adjust as needed)
  //   const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[A-Z0-9]{1}$/;
  //   return gstRegex.test(gst);
  // };

  // update api
  const handleUpdate = async (e) => {
    e.preventDefault();
    // Validate email and phone
    const isEmailValid = validateEmail(email);
    const isPhoneValid = validatePhone(phone);
    // const isGstValid = validateGst(gst);
    setIsEmailValid(isEmailValid);
    setIsPhoneValid(isPhoneValid);
    // setIsGstValid(isGstValid);
    // If both email and phone are valid, proceed with form submission
    if (isEmailValid && isPhoneValid) {
      try {
        const userData = {
          email,
          name,
          phone,
          newPassword,
          device,
          subscription,
          date,
          address,
          proffesion,
          gst,
          cuponapplied,
          collectedamount,
          companyname,
          createdby,
          devicesID,
        };
        const response = await axios.put(
          `${Constant.BASE_URL}/user/updatebyid`,
          userData
        );
        if (response.status === 200) {
          handleClose();
          setEmail("");
          setAddress("");
          setCompanyname("");
          setDate("");
          setName("");
          setSubscription("");
          setPassword("");
          setProffesion("");
          setPhone("");
          setGst("");
          setCollectedamount("");
          setCuponapplied("")
          setDevice("");
          // close the update form
          handleClose();
          // navigate to the main page
          toast.success("User Updated Successfully");
          setTimeout(() => {
            setEditPopup(false);
          }, 3000);
        } else {
          console.log("Update failed:", response.status);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  // handle time
  const handleDateChange = (field, value) => {
    setDate((prevDate) => {
      const updatedDate = { ...prevDate, [field]: value };
      const { day, month, year } = updatedDate;

      if (day && month && year) {
        const dateString = `${year}-${month}-${day},05:30:00`;
        const isoString = new Date(dateString).toLocaleString();
        console.log(isoString, "isoString");

        return isoString;
      }

      return updatedDate;
    });
  };

  var cupondiscount = cuponRes && cuponRes.cupon.find(item => item.cuponcode === cuponapplied)?.cupondiscount;
  var charges = subscriptionRes.subscription.find(item => item.planevalidity === Number(subscription))?.price;
  var cgst = (9 * charges) / 100;
  var sgst = (9 * charges) / 100;
  var scper = charges + cgst + sgst;
  var sc = (2 * scper) / 100;
  var total = cgst + sgst + sc + charges;
  var cupondiscountprice = (cupondiscount * total) / 100;
  var grandtotal = collectedamount;

  return (
    <div className="popup-form">
      <div className="flex items-center justify-center w-full">
        <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md lg:py-3 xl:py-3 2xl:p-4 ">
          <div className="items-center justify-center w-fit">
            <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl ">
              Edit User
            </div>
            <hr className="mt-1 " />
            <form onSubmit={handleUpdate}>
              <div className="flex items-center justify-center lg:py-1 xl:py-5 2xl:py-16 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                <div className="pr-3 border-r ">
                  <div className="flex justify-end py-3">
                    <label
                      htmlFor="yourInput"
                      className="flex items-center px-3 "
                    >
                      Name :<span className="ml-1 text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="yourInput"
                      className="border-b border-gray-500 outline-none createuserline"
                      placeholder="Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="flex justify-end py-3">
                    <label
                      htmlFor="yourInput"
                      className="flex items-center px-3 mb-1"
                    >
                      Phone :<span className="ml-1 text-red-500">*</span>
                    </label>
                    <div className="flex flex-col">
                      <input
                        type="text"
                        id="phone"
                        className="border-b border-gray-500 outline-none createuserline"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        placeholder="Phone"
                        required
                      />
                      {!isPhoneValid && (
                        <p className="text-red-500">
                          Invalid phone format (10 digits)
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="flex justify-end py-3">
                    <label
                      htmlFor="yourIn"
                      className="flex items-center px-3 mb-1"
                    >
                      Email :<span className="ml-1 text-red-500">*</span>
                    </label>
                    <div className="flex flex-col">
                      <input
                        type="email"
                        id="yourIn"
                        className="border-b border-gray-500 outline-none createuserline"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                      {!isEmailValid && (
                        <p className="ml-1 text-red-500">
                          Invalid email format
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="flex justify-end py-3 ">
                    <label
                      htmlFor="yourInput"
                      className="flex items-center px-3 mb-1 "
                    >
                      Password :<span className="ml-1 text-red-500"></span>
                    </label>
                    <input
                      type={togglePassword ? "text" : "password"}
                      id="password"
                      className="relative border-b border-gray-500 outline-none createuserline"
                      placeholder="....."
                      value={newPassword}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                      onClick={() => {
                        setTogglePassword(!togglePassword);
                      }}
                      className="absolute inset-y-0 lg:top-[40px] xl:top-[45px] 2xl:top-[65px] flex items-center pr-2"
                    >
                      {togglePassword ? (
                        <div className="">
                          <IoEye className="text-1xl" />
                        </div>
                      ) : (
                        <div className="">
                          <RiEyeCloseLine className="text-1xl" />
                        </div>
                      )}
                    </span>
                  </div>
                  <div className="flex justify-end py-3">
                    <label
                      htmlFor="yourSelect"
                      className="flex items-center px-3 mb-1"
                    >
                      Device :<span className="ml-1 text-red-500">*</span>
                    </label>
                    <div className="relative borderuser">
                      <select
                        id="yourSelect"
                        className="bg-white border-b border-gray-500 outline-none appearance-none createuserline"
                        required
                        value={device}
                        onChange={(e) => setDevice(e.target.value)}
                      >
                        <option value="" disabled selected>
                          Select{" "}
                        </option>
                        <option value="option1">Android</option>
                        <option value="option2">IOS</option>
                      </select>
                      <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                        <div className="mb-2 bg-white border border-white shadow-md">
                          <MdArrowDropDown className="text-1xl" />
                        </div>
                      </span>
                    </div>
                  </div>

                  <div className="flex justify-end py-3">
                    <label
                      htmlFor="yourSelect"
                      className="flex items-center px-3 mb-1 "
                    >
                      Subscription :<span className="ml-1 text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <select
                        id="yourSelect"
                        className="border-b border-gray-500 outline-none appearance-none createuserline"
                        value={subscription}
                        onChange={(e) => setSubscription(e.target.value)}
                        required
                      >
                        <option value="" disabled selected>
                          Select{" "}
                        </option>
                        {subscriptionRes?.subscription?.map((plan, index) => {
                          if (plan.planevisibility && plan.planevisibility.includes("Affiliate")) {
                            return (
                              <option key={index} value={plan?.planevalidity}>
                                {plan?.planname}
                              </option>
                            );
                          } else {
                            return 'No Coupons Found';
                          }
                        })}
                      </select>
                      {subscription && (
                        <div className="absolute text-gray-600 italic">
                          Subscription Charges: {charges}<br />
                          CGST (9%): {cgst}<br />
                          SGST (9%): {sgst}<br />
                          Service Charges (2%): {sc}<br />
                          <hr className="fw-bolder" />
                          Total: {total};<br />
                          {cuponapplied && (
                            <div>
                              Coupon Discount: {cupondiscount || 0}% ;
                              <hr className="fw-bolder" />
                              Grand Total:{grandtotal}

                            </div>
                          )}
                        </div>
                      )}
                      <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                        <div className="mb-2 bg-white border border-white shadow-md">
                          <MdArrowDropDown className="text-1xl" />
                        </div>
                      </span>
                    </div>
                  </div>
                </div>

                {/* Date started  */}

                <div className="flex-col py-4 pl-1 pr-2 w-fit">
                  <div className="relative flex justify-end py-3">
                    <label
                      htmlFor="yourDateInput"
                      className="flex items-center px-3 mb-1"
                    >
                      Select Date:
                      <span className="ml-1 text-red-500">*</span>
                    </label>
                    <div className="relative flex">
                      {/* Day Select */}
                      <div className="relative">
                        <select
                          id="daySelect"
                          className="border-b border-gray-500 appearance-none outline-none pr-8 text-[9px]"
                          style={{
                            width: "50px",
                            color: "#BBB ",
                            textAlign: "center",
                          }}
                          onChange={(e) =>
                            handleDateChange("day", e.target.value)
                          }
                          value={new Date(date).getDate()}
                          required
                        >
                          <option value="" disabled selected>
                            DD
                          </option>
                          {Array.from({ length: 31 }, (_, i) => (
                            <option key={i + 1} value={i + 1}>
                              {i + 1}
                            </option>
                          ))}
                        </select>
                        <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                          <div className="mb-2 bg-white border border-white shadow-md">
                            <MdArrowDropDown className="text-1xl" />
                          </div>
                        </span>
                      </div>

                      {/* Month Select */}
                      <div className="relative ml-2">
                        <select
                          id="monthSelect"
                          className="border-b border-gray-500 appearance-none outline-none pr-8 text-[9px]"
                          style={{
                            width: "50px",
                            color: "#BBB ",
                            textAlign: "center",
                          }}
                          onChange={(e) =>
                            handleDateChange("month", e.target.value)
                          }
                          value={Number(new Date(date).getMonth()) + 1}
                          required
                        >
                          <option value="" disabled selected>
                            MM
                          </option>
                          {Array.from({ length: 12 }, (_, i) => (
                            <option key={i + 1} value={i + 1}>
                              {i + 1}
                            </option>
                          ))}
                        </select>
                        <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                          <div className="mb-2 bg-white border border-white shadow-md">
                            <MdArrowDropDown className="text-1xl" />
                          </div>
                        </span>
                      </div>

                      {/* Year Select */}
                      <div className="relative ml-2">
                        <select
                          id="yearSelect"
                          className="border-b border-gray-500 appearance-none outline-none pr-8 text-[9px]"
                          style={{
                            width: "50px",
                            color: "#BBB ",
                            textAlign: "center",
                          }}
                          onChange={(e) =>
                            handleDateChange("year", e.target.value)
                          }
                          value={new Date(date).getFullYear()}
                          required
                        >
                          <option value="" disabled selected>
                            YYYY
                          </option>
                          {Array.from({ length: 10 }, (_, i) => (
                            <option key={2022 + i} value={2022 + i}>
                              {2022 + i}
                            </option>
                          ))}
                        </select>
                        <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                          <div className="mb-2 bg-white border border-white shadow-md">
                            <MdArrowDropDown className="text-1xl" />
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Date ended  */}
                  <div className="flex justify-end py-3">
                    <label
                      htmlFor="yourInput"
                      className="flex items-center px-3 mb-1"
                    >
                      Address :<span className="ml-1 text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="yourInput"
                      className="border-b border-gray-500 outline-none createuserline"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      placeholder="Text"
                      required
                    />
                  </div>

                  <div className="flex justify-end py-3">
                    <label
                      htmlFor="yourSelect"
                      className="flex items-center px-3 mb-1 "
                    >
                      Profession :<span className="ml-1 text-red-500">*</span>
                    </label>
                    <div className="relative text-center">
                      <select
                        id="yourSelect"
                        className="border-b border-gray-500 outline-none appearance-none createuserline"
                        style={{ color: "#BBB " }}
                        value={proffesion}
                        onChange={(e) => setProffesion(e.target.value)}
                        required
                      >
                        <option value="" disabled selected>
                          Text{" "}
                        </option>
                        <option value="Fabric Manufacturer">
                          Fabric Manufacturer
                        </option>
                        <option value="Garment Manufacturer">
                          Garment Manufacturer
                        </option>
                        <option value="Yarn Manufacturer">
                          Yarn Manufacturer
                        </option>
                        <option value="Trader & Broker">Trader & Broker</option>
                        <option value="Buyer">Buyer</option>
                        <option value="Designer">Designer</option>
                        <option value="Finisher">Finisher</option>
                        <option value="Other">Other</option>
                      </select>
                      <span className="absolute inset-y-0 right-0 flex items-center pointer-events-none">
                        <div className="mb-2 bg-white border border-white shadow-md">
                          <MdArrowDropDown className="text-1xl" />
                        </div>
                      </span>
                    </div>
                  </div>
                  <div className="flex justify-end py-3">
                    <label
                      htmlFor="yourInput"
                      className="flex items-center px-3 mb-1"
                    >
                      GST Number :
                    </label>
                    <div className="flex flex-col">
                      <input
                        type="text"
                        id="gst"
                        className={`border-b border-gray-500 outline-none createuserline "
                        }`}
                        value={gst}
                        onChange={(e) => setGst(e.target.value)}
                        placeholder="gstnumber"
                      // required
                      />
                      {/* {!isGstValid && (
                        <p className="text-red-500">
                          Invalid GST number (15 digits)
                        </p>
                      )} */}
                    </div>
                  </div>
                  <div className="flex justify-end py-3">
                    <label
                      htmlFor="yourInput"
                      className="flex items-center px-3 mb-1"
                    >
                      Company Name :<span className="text-red-500 ">*</span>
                    </label>
                    <input
                      type="text"
                      id="yourInput"
                      className="border-b border-gray-500 outline-none createuserline"
                      value={companyname}
                      onChange={(e) => setCompanyname(e.target.value)}
                      placeholder="Text"
                      required
                    />
                  </div>
                  <div className="flex justify-end py-3">
                    <label
                      htmlFor="yourInput"
                      className="flex items-center px-3 mb-1"
                    >
                      Created By :<span className="ml-1 text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="yourInput"
                      className="border-b border-gray-500 outline-none createuserline"
                      value={userName}
                      onChange={(e) => setCreatedby(e.target.value)}
                      placeholder="Super Admin (Login Detect)"
                      required
                    />
                  </div>
                  <div className="flex py-3 justify-end">
                    <label
                      htmlFor="yourSelect"
                      className=" mb-1 flex items-center px-3"
                    >
                      Coupon :
                      <span className="text-red-500 ml-1">*</span>
                    </label>
                    <div className="relative ">
                      <select
                        id="cuponapplied"
                        className="border-b border-gray-500 appearance-none outline-none createuserline"
                        value={cuponapplied}
                        onChange={(e) => setCuponapplied(e.target.value)}
                        required
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        {cuponRes?.cupon?.map((plan, index) => {
                          if (plan.cuponassign.includes("Affiliate")) {
                            return (
                              <option key={index} value={plan?.cuponcode}>
                                {plan?.cuponcode}
                              </option>
                            );
                          } else {
                            return "No coupon found";
                          }
                        })}
                      </select>
                      <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                        <div className="bg-white shadow-md border border-white mb-2">
                          <MdArrowDropDown className="text-1xl" />
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="button-container flex justify-center p-1 space-x-12 lg:pb-5 xl:pb-5 2xl:pb-5 
                                        lg:text-[10px] xl:text-[13px] 2xl:text-[22px]"
              >

                <button
                  type="button"
                  onClick={handleClose}
                  className="flex-shrink-0 px-3 py-1 bg-white shadow-md "
                  style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="flex-shrink-0 px-3 py-1 "
                  style={{
                    background:
                      "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                  }}
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AffiliateUserEditform;